'use client';

import React from 'react';
import type { PressableProps } from './primitives.types';

/*
  The DOM half: a real button, so it is reachable by keyboard and announced as a control.

  `onClick` rather than a pointer handler, which is what makes Enter and Space work — and what makes
  a press that wanders off the control before releasing not count, which is the behaviour both
  platforms already have and boards should not have to reimplement.
*/

/** A button inherits none of a div's box, so the parts BoxStyle assumes have to be put back. */
const BUTTON_RESET: React.CSSProperties = {
  appearance: 'none',
  margin: 0,
  padding: 0,
  border: 0,
  background: 'none',
  font: 'inherit',
  color: 'inherit',
  textAlign: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  minWidth: 0,
};

export const Pressable: React.FC<PressableProps> = ({ onPress, disabled, label, selected, style, children }) => (
  <button
    type="button"
    disabled={disabled}
    aria-label={label}
    aria-pressed={selected}
    onClick={onPress}
    style={{
      ...BUTTON_RESET,
      ...(style as React.CSSProperties),
      cursor: disabled ? 'default' : 'pointer',
    }}
  >
    {children}
  </button>
);
